/* LBF popup game system v2 — full-screen layout, everyday (Cream + Maroon Table) and CNY (Maroon Feast) skins.
   Layer 1: swappable mini-game (scratch / flip / wheel). Layer 2: fixed claim form + success screen.
   Every game is a guaranteed win. Sign-ups only leave the browser when "Where sign-ups go" is set to Shopify Forms. */
(function(){
  'use strict';
  var active = null; // the one instance bound to the popup that is currently on the page

  // boot() binds one copy of the popup markup. In the Theme Editor the section is re-rendered every time a
  // setting changes; the old instance is destroyed and a fresh one is booted on the new markup (see the loader
  // at the bottom), so two copies never run at once.
  function boot(){
  var root = document.getElementById('lbf-pop');
  var cfgEl = document.getElementById('lbf-pop-config');
  if(!root || !cfgEl || root.dataset.lbfReady) return null;
  root.dataset.lbfReady = '1';
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch(e) { return null; }
  var dead = false;

  var $ = function(sel){ return root.querySelector('[data-lbf="' + sel + '"]'); };
  var card = $('card'), stack = $('stack');
  var inner = card.querySelector('.lbf-pop-inner');
  var fx = document.createElement('div'); fx.className = 'lbf-pop-fx'; fx.setAttribute('aria-hidden','true'); stack.appendChild(fx);
  var stageGame = $('stage-game'), stageForm = $('stage-form'), stageSuccess = $('stage-success');
  var step1 = $('step-1'), step2 = $('step-2');
  var emailInput = $('email'), emailError = $('email-error');
  var blocks = {};
  root.querySelectorAll('[data-lbf-game]').forEach(function(b){ blocks[b.getAttribute('data-lbf-game')] = b; });
  function setScreen(n){ card.setAttribute('data-screen', n); }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- storage (cookie + localStorage, both wrapped: private mode / blocked storage must never break the page) ----------
  var KEY = 'lbf_pop_v1';
  function readState(){
    var v = null;
    try { v = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch(e) {}
    if(!v){ var m = document.cookie.match(/(?:^|; )lbf_pop_v1=([^;]*)/); if(m){ try { v = JSON.parse(decodeURIComponent(m[1])); } catch(e) {} } }
    return v || {};
  }
  function writeState(v){
    var str = JSON.stringify(v);
    try { localStorage.setItem(KEY, str); } catch(e) {}
    try { document.cookie = KEY + '=' + encodeURIComponent(str) + ';path=/;max-age=' + (60*60*24*365) + ';SameSite=Lax'; } catch(e) {}
  }
  function clearState(){
    try { localStorage.removeItem(KEY); } catch(e) {}
    document.cookie = KEY + '=;path=/;max-age=0';
  }
  function inCooldown(){
    var st = readState();
    if(st.converted) return true;
    var days = Number(cfg.cooldownDays);
    if(!(days > 0) || !st.shown) return false;
    return (Date.now() - st.shown) < days * 864e5;
  }
  function markShown(){ var st = readState(); st.shown = Date.now(); writeState(st); }
  function markConverted(){ var st = readState(); st.converted = Date.now(); writeState(st); }

  // ---------- which game ----------
  function pickGame(){
    var g = cfg.game, all = ['scratch','flip','wheel'];
    if(g === 'random') return all[Math.floor(Math.random()*3)];
    if(g === 'rotate'){ var st = readState(); var i = ((st.rot || 0) + 1) % 3; st.rot = i; writeState(st); return all[i]; }
    return all.indexOf(g) > -1 ? g : 'scratch';
  }

  // ---------- open / close ----------
  var currentGame = null, isOpen = false, lastFocus = null;
  function preloadSuccessImages(){
    root.querySelectorAll('img[data-src]').forEach(function(img){ img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); });
  }
  // the stylesheets load async (non-blocking); never open before they have applied, otherwise the
  // screens are measured at the wrong size (scratch canvas, the locked content height). On a slow connection
  // it keeps waiting (up to 20 s); if the styles never arrive the popup simply doesn't open.
  function styledNow(){
    if(getComputedStyle(root).position !== 'fixed') return false;
    var tbl = root.querySelector('.lbf-pop-table'); // CNY skin: lbf-pop-cny.css must have applied as well
    if(tbl && String(getComputedStyle(tbl).aspectRatio).indexOf('1584') < 0) return false;
    return true;
  }
  function whenStyled(cb){
    if(dead) return;
    if(styledNow()) return cb();
    var t0 = Date.now();
    (function poll(){ if(dead) return; if(styledNow()) return requestAnimationFrame(cb); if(Date.now() - t0 > 20000) return; setTimeout(poll, 80); })();
  }
  var openReq = 0;
  function openPopup(game, opts){
    var id = ++openReq; // only the latest request opens (no double open while waiting for the styles)
    whenStyled(function(){ if(id === openReq && !dead) openNow(game, opts); });
  }
  function openNow(game, opts){
    opts = opts || {};
    clearGameTimer(); stopConfetti();
    currentGame = game;
    Object.keys(blocks).forEach(function(k){ blocks[k].hidden = (k !== game); });
    stageGame.hidden = false; stageForm.hidden = true; stageSuccess.hidden = true;
    setScreen(game);
    card.classList.remove('lbf-pop-hero-out','lbf-pop-resizing'); card.style.removeProperty('--lbf-hero-gap');
    inner.classList.remove('lbf-pop-swap-out','lbf-pop-swap-in','lbf-pop-resizing'); inner.style.height = '';
    lastFocus = document.activeElement;
    root.hidden = false;
    isOpen = true;
    // set the game up and fix the popup's position BEFORE the first frame is painted,
    // so nothing grows or shifts after it appears
    if(game === 'scratch') initScratch();
    if(game === 'flip') initFlip();
    if(game === 'wheel') initWheel();
    lockInnerHeight();
    positionStack();
    // the web fonts can swap in after opening and change the heights: measure again once they're ready
    if(document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ if(isOpen && card.getAttribute('data-screen') === game){ lockInnerHeight(); positionStack(); } });
    requestAnimationFrame(function(){ root.classList.add('lbf-pop-open'); });
    if(!opts.noMute) markShown(); // the cooldown starts the instant the popup shows
    preloadSuccessImages();
    requestAnimationFrame(function(){
      try { card.focus({preventScroll:true}); } catch(e) {} // focus the dialog itself, not the close button (no focus ring on open)
    });
    lockPage(true);
    root.dispatchEvent(new CustomEvent('lbf-pop:open', {bubbles:true, detail:{game:game}}));
  }
  // The popup is centred once, when it opens, and its top edge then stays put for every later screen:
  // only the bottom edge moves as the card changes height, so the header never jumps.
  // Re-centred only when the screen WIDTH changes (rotation), never on height changes such as
  // the phone keyboard opening or the browser toolbar hiding.
  var lastVW = 0;
  function positionStack(){
    lastVW = window.innerWidth;
    var h = stack.offsetHeight;
    stack.style.marginTop = Math.max(0, Math.round((window.innerHeight - 40 - h) / 2)) + 'px';
  }
  function onResize(){
    if(isOpen && window.innerWidth !== lastVW && !inner.classList.contains('lbf-pop-resizing')){ if(card.getAttribute('data-screen') !== 'success') lockInnerHeight(); positionStack(); }
  }
  window.addEventListener('resize', onResize);
  // speed fix 12 Oct 2026: pause the pop-up's looping CSS animations while the tab is hidden
  function onVis(){ root.classList.toggle('lbf-pop-paused', document.hidden); }
  document.addEventListener('visibilitychange', onVis);
  // Stop the page behind from scrolling. On desktop the page scrollbar would vanish and the whole popup would
  // slide sideways by the scrollbar's width - scrollbar-gutter keeps that space reserved, so nothing moves.
  function lockPage(on){
    var html = document.documentElement;
    if(on){
      var sb = window.innerWidth - html.clientWidth;
      html.style.overflow = 'hidden';
      if(sb > 0) html.style.scrollbarGutter = 'stable';
    } else {
      html.style.overflow = '';
      html.style.scrollbarGutter = '';
    }
  }
  function closePopup(){
    if(!isOpen) return;
    isOpen = false;
    clearGameTimer(); stopConfetti(); clearTimeout(swapTimer);
    root.classList.remove('lbf-pop-open');
    lockPage(false);
    setTimeout(function(){ if(!isOpen) root.hidden = true; }, 220);
    if(lastFocus && lastFocus.focus) try { lastFocus.focus({preventScroll:true}); } catch(e) {}
  }
  $('close').addEventListener('click', closePopup);
  // full screen: only the X (top left) or Esc closes it, never a tap on the background
  function onKey(e){ if(isOpen && e.key === 'Escape') closePopup(); }
  document.addEventListener('keydown', onKey);
  $('redirect').addEventListener('click', function(){ closePopup(); });

  // ---------- celebration kit ----------
  // pause between the win and the claim form - set in the Theme Editor (Timing), 2.6 s by default
  var WIN_HOLD = Math.round(Math.min(8, Math.max(.5, Number(cfg.winHold) || 2.6)) * 1000);
  var gameTimer = null;
  function clearGameTimer(){ clearTimeout(gameTimer); gameTimer = null; }
  function burst(x, y, n){
    if(reduceMotion) return;
    n = n || 18;
    var colors = ['#be995c','#ffe100','#be995c','#fff7ef'];
    for(var i=0;i<n;i++){
      var s = document.createElement('span');
      s.className = 'lbf-pop-spk';
      var ang = (i/n)*Math.PI*2 + Math.random()*.4;
      var dist = 50 + Math.random()*70;
      var star = Math.random() > .35;
      s.textContent = star ? '✦' : '●';
      s.style.cssText = 'left:'+x+'px;top:'+y+'px;color:'+colors[i%colors.length]+';font-size:'+(star ? 11+Math.random()*13 : 5+Math.random()*4)+'px;'+
        '--dx:'+(Math.cos(ang)*dist)+'px;--dy:'+(Math.sin(ang)*dist)+'px;--r:'+(Math.random()*180-90)+'deg;--t:'+(.7+Math.random()*.4)+'s;';
      fx.appendChild(s);
      (function(el){ setTimeout(function(){ el.remove(); }, 1300); })(s);
    }
  }
  function pointOf(el, fx, fy){ var r = el.getBoundingClientRect(); return {x:r.left + r.width*(fx==null?.5:fx), y:r.top + r.height*(fy==null?.5:fy)}; }
  function celebrate(block, points){
    block.classList.remove('lbf-pop-celebrate'); void block.offsetWidth; block.classList.add('lbf-pop-celebrate');
    var r = stack.getBoundingClientRect(), sc = stack.offsetWidth / r.width; // undo the open-animation scale
    points.forEach(function(p,i){ setTimeout(function(){ burst((p.x - r.left)*sc, (p.y - r.top)*sc); }, i*90); });
    if(navigator.vibrate) try { navigator.vibrate([30,40,30]); } catch(e) {}
  }

  // ---------- scratch card ----------
  var ticket = $('ticket'), foil = $('foil'), sctx = foil ? foil.getContext('2d', {willReadFrequently:true}) : null;
  var BRUSH = 22.5, REVEAL_AT = .5; // brush radius (a 45px-wide path); the prize reveals once 50% of the foil is cleared
  var scratchDone = false, scratchDown = false, scratchRaf = false, scratchLast = null;
  function paintFoil(){
    var cny = root.getAttribute('data-skin') === 'cny';
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = ticket.clientWidth, h = ticket.clientHeight;
    foil.width = Math.round(w*dpr); foil.height = Math.round(h*dpr);
    sctx.setTransform(dpr,0,0,dpr,0,0);
    sctx.globalCompositeOperation = 'source-over';
    {
      var g = sctx.createLinearGradient(0,0,w,h);
      var cs = cny ? ['#c9953a','#e8b84a','#fbe3a6','#e8b84a','#c9953a'] : ['#a8854b','#be995c','#ecd8ab','#be995c','#a8854b'], st = [0,.38,.5,.62,1];
      for(var i=0;i<5;i++) g.addColorStop(st[i], cs[i]);
      sctx.fillStyle = g;
    }
    sctx.fillRect(0,0,w,h);
    sctx.fillStyle = 'rgba(255,247,239,.16)'; sctx.font = '12px sans-serif'; sctx.textAlign = 'center'; sctx.textBaseline = 'middle';
    for(var y=14;y<h;y+=26) for(var x=(y/26%2?14:27);x<w;x+=26) sctx.fillText('✦', x, y);
  }
  function initScratch(){
    clearGameTimer();
    scratchDone = false; scratchDown = false; scratchLast = null;
    blocks.scratch.classList.remove('lbf-pop-celebrate');
    ticket.classList.remove('lbf-pop-scratching','lbf-pop-revealed');
    paintFoil();
  }
  function scratchPos(e){
    var r = foil.getBoundingClientRect(), s = ticket.clientWidth / r.width;
    return { x:(e.clientX - r.left)*s, y:(e.clientY - r.top)*s };
  }
  function scratchAt(p){
    sctx.globalCompositeOperation = 'destination-out';
    sctx.lineWidth = BRUSH*2; sctx.lineCap = 'round'; sctx.lineJoin = 'round';
    var from = scratchLast || p;
    sctx.beginPath(); sctx.moveTo(from.x, from.y); sctx.lineTo(p.x + (from === p ? .01 : 0), p.y); sctx.stroke();
    scratchLast = p; checkScratch();
  }
  function checkScratch(){
    if(scratchRaf || scratchDone) return;
    scratchRaf = true;
    requestAnimationFrame(function(){
      scratchRaf = false;
      if(scratchDone) return;
      var d = sctx.getImageData(0,0,foil.width,foil.height).data, cleared = 0, total = 0;
      for(var i=3;i<d.length;i+=64){ total++; if(d[i] < 40) cleared++; }
      if(total && cleared/total > REVEAL_AT) revealScratch();
    });
  }
  function revealScratch(){
    scratchDone = true; scratchDown = false;
    ticket.classList.add('lbf-pop-revealed');
    setTimeout(function(){ celebrate(blocks.scratch, [pointOf(ticket), pointOf(ticket,.2,.3), pointOf(ticket,.8,.7)]); }, 250);
    gameTimer = setTimeout(goToClaimForm, 250 + WIN_HOLD);
  }
  if(foil){
    // repaint the foil if the ticket changes size before the first scratch (font swap, rotation)
    if(window.ResizeObserver){
      var lastW = 0;
      new ResizeObserver(function(){
        var w = ticket.clientWidth;
        if(!w || w === lastW) return; lastW = w;
        if(isOpen && currentGame === 'scratch' && !scratchDone && !ticket.classList.contains('lbf-pop-scratching')) paintFoil();
      }).observe(ticket);
    }
    foil.addEventListener('pointerdown', function(e){
      if(scratchDone) return;
      e.preventDefault();
      scratchDown = true; scratchLast = null;
      ticket.classList.add('lbf-pop-scratching');
      try { foil.setPointerCapture(e.pointerId); } catch(err) {}
      scratchAt(scratchPos(e));
    });
    foil.addEventListener('pointermove', function(e){ if(scratchDown && !scratchDone) scratchAt(scratchPos(e)); });
    ['pointerup','pointercancel'].forEach(function(t){ foil.addEventListener(t, function(){ scratchDown = false; scratchLast = null; }); });
  }

  // ---------- flip & match ----------
  var flipGrid = $('flip-grid'), flipOpen = [], flipLock = false;
  function esc(t){ var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
  function initFlip(){
    clearGameTimer();
    flipOpen = []; flipLock = false;
    blocks.flip.classList.remove('lbf-pop-celebrate');
    var html = '';
    for(var i=0;i<9;i++){
      html += '<button type="button" class="lbf-pop-fcard" aria-label="Mystery card"><span class="lbf-pop-fc-inner">' +
        '<span class="lbf-pop-fc-face lbf-pop-fc-down">?</span>' +
        '<span class="lbf-pop-fc-face lbf-pop-fc-up lbf-pop-plabel"><small>' + esc(cfg.prizeSmall) + '</small><b>' + esc(cfg.prizeBig) + '</b><span class="lbf-pop-shine"></span></span>' +
        '</span></button>';
    }
    flipGrid.innerHTML = html;
  }
  flipGrid.addEventListener('click', function(e){
    var c = e.target.closest('.lbf-pop-fcard');
    if(!c || flipLock || c.classList.contains('lbf-pop-flipped')) return;
    c.classList.add('lbf-pop-flipped');
    c.setAttribute('aria-label', cfg.rewardName || 'Reward');
    flipOpen.push(c);
    if(flipOpen.length === 2){
      flipLock = true;
      var pair = flipOpen;
      setTimeout(function(){
        pair.forEach(function(x){ x.classList.add('lbf-pop-matched'); });
        celebrate(blocks.flip, pair.map(function(x){ return pointOf(x); }));
      }, 520);
      gameTimer = setTimeout(goToClaimForm, 520 + WIN_HOLD);
    }
  });

  // ---------- spin wheel ----------
  var wheelEl = $('wheel'), spinBtn = $('spin'), spinLabel = $('spin-label'), wheelSpinning = false;
  var spinText = spinLabel ? spinLabel.textContent : 'Spin';
  function setSpinning(on){
    spinBtn.classList.toggle('lbf-pop-is-spinning', on);
    if(spinLabel) spinLabel.textContent = on ? (cfg.spinningLabel || 'Spinning…') : spinText;
  }
  function initWheel(){
    clearGameTimer();
    blocks.wheel.classList.remove('lbf-pop-celebrate');
    wheelEl.style.transition = 'none';
    wheelEl.style.transform = 'rotate(0deg)';
    void wheelEl.offsetWidth;
    spinBtn.disabled = false;
    wheelSpinning = false;
    setSpinning(false);
  }
  function wheelLanded(){
    if(!wheelSpinning) return;
    wheelSpinning = false;
    setSpinning(false); // back to "Spin" (still disabled) the moment the wheel stops
    var wrap = wheelEl.parentElement;
    celebrate(blocks.wheel, [pointOf(wrap,.5,.2), pointOf(wrap,.36,.28), pointOf(wrap,.64,.28)]);
    gameTimer = setTimeout(goToClaimForm, WIN_HOLD);
  }
  spinBtn.addEventListener('click', function(){
    if(wheelSpinning) return;
    wheelSpinning = true;
    spinBtn.disabled = true;
    setSpinning(true);
    var target = 150 + 360*5; // lands the pointer on the prize slice (180°–240°)
    wheelEl.style.transition = 'transform ' + (reduceMotion ? '1.2s' : '4.2s') + ' cubic-bezier(.15,.75,.1,1)';
    wheelEl.style.transform = 'rotate(' + target + 'deg)';
    clearGameTimer();
    gameTimer = setTimeout(wheelLanded, reduceMotion ? 1400 : 4500); // fallback if transitionend never fires
  });
  // only act while still spinning: if the fallback timer already landed the wheel, a late transitionend must not cancel the claim-form timer
  wheelEl.addEventListener('transitionend', function(e){ if(e.target === wheelEl && e.propertyName === 'transform' && wheelSpinning){ clearGameTimer(); wheelLanded(); } });

  // ---------- smooth stage swap ----------
  // 1. the old screen fades out (0.15 s)
  // 2. the DOM swaps; the content box eases from the old height to the new one (0.32 s) while the new
  //    screen fades in on top of it. The top edge stays fixed; the bottom edge is clipped so nothing
  //    spills out while it grows. Heights are measured to the sub-pixel so there's no snap at the end.
  var swapTimer = null;
  function exactHeight(el){
    var sc = stack.getBoundingClientRect().width / (stack.offsetWidth || 1) || 1;
    return el.getBoundingClientRect().height / sc;
  }
  // Short phones: the game, question and email screens need different heights, and one taller than the screen
  // would push the carton (CNY: the table) down. Every screen before success gets the height of the tallest,
  // so the carton stays exactly where it is until the success screen.
  function lockInnerHeight(){
    inner.style.minHeight = '';
    var keep = [stageGame.hidden, stageForm.hidden, step1.hidden, step2.hidden], fl = inner.style.flex, hs = [];
    inner.style.flex = '0 0 auto';
    stageGame.hidden = false; stageForm.hidden = true; hs.push(exactHeight(inner));
    stageGame.hidden = true; stageForm.hidden = false; step1.hidden = false; step2.hidden = true; hs.push(exactHeight(inner));
    step1.hidden = true; step2.hidden = false; hs.push(exactHeight(inner));
    stageGame.hidden = keep[0]; stageForm.hidden = keep[1]; step1.hidden = keep[2]; step2.hidden = keep[3];
    inner.style.flex = fl;
    inner.style.minHeight = Math.ceil(Math.max.apply(null, hs)) + 'px';
  }
  function swapStage(change, done){
    clearTimeout(swapTimer);
    if(reduceMotion || !isOpen){ change(); if(done) done(); return; }
    inner.classList.add('lbf-pop-swap-out');
    swapTimer = setTimeout(function(){
      var from = exactHeight(inner);
      card.classList.add('lbf-pop-resizing');
      inner.classList.add('lbf-pop-resizing','lbf-pop-swap-in');
      inner.classList.remove('lbf-pop-swap-out');
      inner.style.height = from + 'px';
      change();
      inner.style.height = 'auto';
      var to = exactHeight(inner);
      inner.style.height = from + 'px';
      void inner.offsetHeight;
      function finish(){
        inner.classList.remove('lbf-pop-resizing','lbf-pop-swap-in');
        card.classList.remove('lbf-pop-resizing');
        inner.style.height = '';
        if(done) done();
      }
      // success fills the screen (its content is spaced against the carton), so it just fades in once its layout has settled
      if(Math.abs(to - from) < 1 || to > window.innerHeight * .8 || card.getAttribute('data-screen') === 'success'){ // nothing to animate, or taller than the card can show
        inner.style.height = '';
        void inner.offsetHeight;
        inner.classList.remove('lbf-pop-swap-in');
        swapTimer = setTimeout(finish, 320);
        return;
      }
      inner.classList.remove('lbf-pop-swap-in');
      inner.style.height = to + 'px';
      swapTimer = setTimeout(finish, 340);
    }, 150);
  }

  // ---------- claim form ----------
  var purpose = '';
  var finePointerDevice = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var radios = root.querySelectorAll('input[name="lbf-pop-purpose"]');
  function goToClaimForm(){
    swapStage(function(){
      stageGame.hidden = true; stageForm.hidden = false; setScreen('q');
      step1.hidden = false; step2.hidden = true;
      emailInput.value = ''; emailInput.classList.remove('lbf-pop-invalid'); emailError.hidden = true;
      purpose = '';
      radios.forEach(function(r){ r.checked = false; r.parentElement.classList.remove('lbf-pop-checked'); });
      card.scrollTop = 0; root.scrollTop = 0;
    });
  }
  radios.forEach(function(r){
    // click (not change) so re-picking the same option on a second playthrough still advances
    r.addEventListener('click', function(){
      purpose = r.value;
      radios.forEach(function(x){ x.parentElement.classList.toggle('lbf-pop-checked', x === r); });
      setTimeout(function(){
        swapStage(function(){ step1.hidden = true; step2.hidden = false; setScreen('email'); }, function(){
          // desktop only: on phones, auto-focusing would pop the keyboard open and shove the page around
          if(finePointerDevice) try { emailInput.focus({preventScroll:true}); } catch(e) {}
        });
      }, 280);
    });
  });
  function emailOk(){
    var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(emailInput.value.trim());
    emailInput.classList.toggle('lbf-pop-invalid', !ok);
    emailError.hidden = ok;
    if(!ok) emailInput.focus();
    return ok;
  }
  emailInput.addEventListener('input', function(){ if(!emailError.hidden){ emailInput.classList.remove('lbf-pop-invalid'); emailError.hidden = true; } });
  emailInput.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); submitClaim(); } });
  $('submit').addEventListener('click', submitClaim);

  var submitting = false;
  // Continue shows a small turning ring while Shopify Forms confirms the sign-up (about 2 s)
  var submitBtn = $('submit');
  function setSending(on){
    if(on && !submitBtn.querySelector('.lbf-pop-spinner')){
      var sp = document.createElement('span'); sp.className = 'lbf-pop-spinner'; sp.setAttribute('aria-hidden','true');
      submitBtn.insertBefore(sp, submitBtn.firstChild); submitBtn.style.gap = '10px';
    }
    submitBtn.classList.toggle('lbf-pop-is-spinning', on);
    submitBtn.disabled = on;
    submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function submitClaim(){
    if(submitting || !emailOk()) return;
    var data = { email: emailInput.value.trim(), purpose: purpose, game: currentGame, reward: cfg.rewardName };
    root.dispatchEvent(new CustomEvent('lbf-pop:claim', {bubbles:true, detail:data}));
    if(cfg.handoff === 'forms' && !cfg.designMode){
      submitting = true;
      setSending(true);
      handoffToForms(data).then(function(ok){
        submitting = false;
        setSending(false);
        if(ok){ markConverted(); showSuccess(); }
        else { emailError.textContent = 'Sorry, something went wrong. Please try again.'; emailError.hidden = false; }
      });
    } else {
      // Preview mode: nothing leaves the browser. Useful for design review in the draft theme.
      if(window.console) console.info('[lbf-pop] preview mode, sign-up not sent:', data);
      showSuccess();
    }
  }

  // ---------- Shopify Forms teaser handoff ----------
  // Forms' teaser ("First (before the form)") is clicked by script, the opened Forms popup is kept invisible,
  // its fields are filled and its own submit button is pressed. Selectors come from the Theme Editor
  // because they can only be confirmed with a live test in this theme.
  function deepQuery(sel, scope){
    if(!sel) return null;
    scope = scope || document;
    var hit = null;
    try { hit = scope.querySelector(sel); } catch(e) { return null; }
    if(hit) return hit;
    if(scope.shadowRoot){ hit = deepQuery(sel, scope.shadowRoot); if(hit) return hit; } // scope can be the Forms host element itself
    var all = scope.querySelectorAll('*');
    for(var i=0;i<all.length;i++){ if(all[i].shadowRoot){ hit = deepQuery(sel, all[i].shadowRoot); if(hit) return hit; } }
    return null;
  }
  function waitFor(fn, ms){
    return new Promise(function(res){
      var t0 = Date.now();
      (function loop(){ var v = fn(); if(v) return res(v); if(Date.now() - t0 > ms) return res(null); setTimeout(loop, 120); })();
    });
  }
  function setVal(el, v){
    var proto = el.tagName === 'SELECT' ? HTMLSelectElement.prototype : (el.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype);
    var desc = Object.getOwnPropertyDescriptor(proto, 'value');
    if(el.type === 'radio' || el.type === 'checkbox'){ el.checked = true; }
    else if(desc && desc.set){ desc.set.call(el, v); } else { el.value = v; }
    el.dispatchEvent(new Event('input', {bubbles:true, composed:true}));
    el.dispatchEvent(new Event('change', {bubbles:true, composed:true}));
  }
  function handoffToForms(data){
    var html = document.documentElement;
    html.classList.add('lbf-pop-handoff');
    var rootEl = cfg.formsRoot ? deepQuery(cfg.formsRoot) : null;
    var teaser = deepQuery(cfg.formsTeaser, rootEl || document);
    if(!teaser){ html.classList.remove('lbf-pop-handoff'); console.warn('[lbf-pop] Forms teaser not found:', cfg.formsTeaser); return Promise.resolve(false); }
    teaser.setAttribute('data-lbf-forms-hide', '');
    teaser.click();
    return waitFor(function(){ return deepQuery(cfg.formsEmail, cfg.formsRoot ? deepQuery(cfg.formsRoot) || document : document); }, 6000).then(function(email){
      if(!email){ html.classList.remove('lbf-pop-handoff'); console.warn('[lbf-pop] Forms email field not found'); return false; }
      var formRoot = cfg.formsRoot ? deepQuery(cfg.formsRoot) : null;
      if(formRoot) formRoot.setAttribute('data-lbf-forms-hide', '');
      // Shopify Forms runs an invisible hCaptcha check. Submitting the instant the form opens fails with
      // "Authentication failed", so wait for the check to load and settle first.
      var t0 = Date.now();
      return waitFor(function(){ return deepQuery('iframe[src*="hcaptcha"]', formRoot || document); }, 6000).then(function(){
        return new Promise(function(res){ setTimeout(res, Math.max(0, 1200 - (Date.now() - t0))); });
      }).then(function(){
      setVal(email, data.email);
      if(cfg.formsPurpose){
        var p = deepQuery(cfg.formsPurpose.indexOf('{value}') > -1 ? cfg.formsPurpose.replace('{value}', data.purpose) : cfg.formsPurpose);
        if(p) setVal(p, data.purpose);
      }
      return new Promise(function(res){ setTimeout(res, 300); });
      }).then(function(){
      var scope = email.form || formRoot || document;
      var btn = deepQuery(cfg.formsSubmit, scope) || (formRoot ? deepQuery(cfg.formsSubmit, formRoot) : null);
      if(btn) btn.click(); else if(email.form && email.form.requestSubmit) email.form.requestSubmit();
      else { html.classList.remove('lbf-pop-handoff'); console.warn('[lbf-pop] Forms submit button not found'); return false; }
      // Wait for Forms to confirm: its step becomes "success". "error" means Shopify rejected the sign-up
      // (e.g. the bot check failed), and a field marked invalid means the form refused the input.
      var stepScope = formRoot || document;
      return waitFor(function(){
        var st = deepQuery('[data-current-step]', stepScope);
        var step = st && st.getAttribute('data-current-step');
        if(step === 'success') return 'ok';
        if(step === 'error') return 'error';
        if(email.isConnected && deepQuery('[aria-invalid="true"]', email.form || stepScope)) return 'invalid';
        return null;
      }, 12000).then(function(res){
        html.classList.remove('lbf-pop-handoff');
        if(res !== 'ok') console.warn('[lbf-pop] Forms did not confirm the sign-up:', res || 'timeout');
        return res === 'ok';
      });
      });
    });
  }

  // ---------- success ----------
  function showSuccess(){
    var hero = !stageSuccess.classList.contains('lbf-pop-no-hero');
    try { emailInput.blur(); } catch(e) {} // closes the phone keyboard before the resize, so the viewport doesn't jump mid-animation
    root.querySelectorAll('.lbf-pop-pkg').forEach(function(el){ el.classList.remove('lbf-pop-play'); });
    swapStage(function(){
      stageForm.hidden = true;
      stageSuccess.hidden = false; setScreen('success'); inner.style.minHeight = '';
      if(hero){
        // the carton pops out ~94px above the card: only push the card down if there isn't room above it
        var top = card.getBoundingClientRect().top;
        card.style.setProperty('--lbf-hero-gap', Math.max(0, Math.ceil(106 - top)) + 'px');
      }
      card.classList.toggle('lbf-pop-hero-out', hero);
      card.scrollTop = 0; root.scrollTop = 0;
      // the packs pop out of the box and the confetti starts falling at the same moment, while the text fades in
      requestAnimationFrame(function(){
        root.querySelectorAll('.lbf-pop-pkg').forEach(function(el){ void el.offsetWidth; el.classList.add('lbf-pop-play'); });
        fireConfetti(hero);
      });
    });
  }

  // ---------- confetti: falls from the top of the screen, success screen only ----------
  var cCanvas = document.createElement('canvas');
  cCanvas.className = 'lbf-pop-confetti';
  cCanvas.setAttribute('aria-hidden', 'true');
  root.appendChild(cCanvas);
  var cctx = cCanvas.getContext('2d');
  var confetti = [], confettiRaf = null, confettiTimer = null;
  function stopConfetti(){ clearTimeout(confettiTimer); confetti = []; cancelAnimationFrame(confettiRaf); confettiRaf = null; cctx.clearRect(0,0,cCanvas.width,cCanvas.height); }
  function fireConfetti(hero){
    stopConfetti();
    if(reduceMotion) return;
    confettiTimer = setTimeout(function(){
      var d = Math.min(window.devicePixelRatio || 1, 2);
      cCanvas.width = Math.round(innerWidth*d); cCanvas.height = Math.round(innerHeight*d);
      cctx.setTransform(d,0,0,d,0,0);
      var cny = root.getAttribute('data-skin') === 'cny';
      var pal = cny ? ['#a3151a','#c92a2f','#be995c','#ffe100','#fff7ef'] : ['#841d20','#6b1719','#be995c','#be995c','#ffe100','#fff7ef'];
      var rnd = function(a,b){ return a + Math.random()*(b-a); };
      // spread across the full width; some pieces start on screen at the top so the fall is visible from the first frame
      for(var i=0;i<90;i++){
        confetti.push({x:rnd(0, innerWidth), y:rnd(-innerHeight*.3, innerHeight*.08), vx:rnd(-1.2,1.2), vy:rnd(2,5),
          w:rnd(10,15), h:rnd(15,21), rot:rnd(0,6.28), vr:rnd(-.12,.12), ph:rnd(0,6.28), vph:rnd(.07,.12),
          color:pal[Math.floor(Math.random()*pal.length)], circle:Math.random() < .2,
          coin: cny && Math.random() < .28, life:0, max:rnd(200,250)});
      }
      if(!confettiRaf) confettiRaf = requestAnimationFrame(tick);
    }, 0);
  }
  function tick(){
    cctx.clearRect(0,0,innerWidth,innerHeight);
    confetti = confetti.filter(function(p){ return p.life < p.max && p.y < innerHeight + 30; });
    confetti.forEach(function(p){
      p.life++; p.vy += .13; p.vx *= .968; p.vy *= .968; p.ph += p.vph;
      p.x += p.vx + Math.sin(p.ph)*.45; p.y += p.vy; p.rot += p.vr;
      cctx.save(); cctx.translate(p.x, p.y);
      cctx.globalAlpha = p.life > p.max-40 ? Math.max(0,(p.max-p.life)/40) : 1;
      if(p.coin){ cctx.font = '24px sans-serif'; cctx.textAlign = 'center'; cctx.textBaseline = 'middle'; cctx.fillText('🪙', 0, 0); }
      else {
        cctx.fillStyle = p.color; cctx.rotate(p.rot); cctx.scale(1, Math.cos(p.ph));
        if(p.circle){ cctx.beginPath(); cctx.arc(0,0,p.w*.5,0,6.28); cctx.fill(); } else cctx.fillRect(-p.w/2,-p.h/2,p.w,p.h);
      }
      cctx.restore();
    });
    confettiRaf = confetti.length ? requestAnimationFrame(tick) : null;
  }

  // ---------- public hook + QA ----------
  function destroy(){
    dead = true;
    clearGameTimer(); stopConfetti(); clearTimeout(swapTimer); cleanup();
    if(isOpen){ isOpen = false; lockPage(false); }
    root.classList.remove('lbf-pop-open'); root.hidden = true;
    document.removeEventListener('keydown', onKey);
    window.removeEventListener('resize', onResize);
    document.removeEventListener('visibilitychange', onVis);
  }
  var api = {
    open: function(g, opts){ openPopup(g || pickGame(), opts || {noMute:true}); },
    close: closePopup, reset: clearState, destroy: destroy, root: root, cfg: cfg
  };
  window.LBFPopup = api;

  var qp = null;
  try { qp = new URLSearchParams(location.search).get('lbf_pop'); } catch(e) {}
  if(qp === 'reset'){ clearState(); qp = null; }

  // Theme Editor: no automatic trigger; the loader below opens it when the section is selected
  if(cfg.designMode){
    if(qp && blocks[qp]) openPopup(qp, {noMute:true});
    return api;
  }

  if(qp && (blocks[qp] || qp === '1')){ openPopup(blocks[qp] ? qp : pickGame(), {noMute:true}); return api; }
  if(!cfg.enabled || inCooldown()) return api;

  // ---------- trigger ----------
  var fired = false;
  function fire(){ if(fired || isOpen || dead) return; fired = true; cleanup(); openPopup(pickGame()); }
  var delayTimer = null;
  function onScroll(){
    var h = document.documentElement.scrollHeight - innerHeight;
    if(h <= 0) return;
    if((window.scrollY / h) * 100 >= Number(cfg.scroll || 40)) fire();
  }
  function onExit(e){ if(!e.relatedTarget && e.clientY <= 0) fire(); }
  function cleanup(){ clearTimeout(delayTimer); window.removeEventListener('scroll', onScroll); document.removeEventListener('mouseout', onExit); }
  var t = cfg.trigger, delayMs = Math.max(0, Number(cfg.delay || 0)) * 1000;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if(t === 'scroll' || t === 'delay-or-scroll') window.addEventListener('scroll', onScroll, {passive:true});
  if(t === 'delay' || t === 'delay-or-scroll' || (t === 'exit' && !finePointer)) delayTimer = setTimeout(fire, delayMs);
  if(t === 'exit' && finePointer) document.addEventListener('mouseout', onExit);
  return api;
  } // end boot

  // ---------- loader ----------
  function load(){
    var el = document.getElementById('lbf-pop');
    if(active && active.root === el) return active;
    var inst = boot();
    if(inst){ if(active) active.destroy(); active = inst; }
    return inst;
  }
  // if the Theme Editor re-runs this file after a re-render, reuse the first loader instead of adding a second one
  if(window.__lbfPopLoad){ window.__lbfPopLoad(); return; }
  window.__lbfPopLoad = load;
  load();

  if(window.Shopify && window.Shopify.designMode){
    var ours = function(e){ return e.target && e.target.querySelector && e.target.querySelector('#lbf-pop'); };
    // a setting changed: the old popup is thrown away and the new one opens straight away so the change is visible
    document.addEventListener('shopify:section:unload', function(e){ if(active && ours(e)){ active.destroy(); active = null; } });
    document.addEventListener('shopify:section:load', function(e){ if(!ours(e)) return; var inst = load(); if(inst) inst.open(); });
    document.addEventListener('shopify:section:select', function(e){ if(active && e.detail && e.detail.sectionId === active.cfg.sectionId) active.open(); });
    document.addEventListener('shopify:section:deselect', function(e){ if(active && e.detail && e.detail.sectionId === active.cfg.sectionId) active.close(); });
  }
})();